import { useSnapshot } from 'valtio';

import { Job, JobStatus } from '../types';
import getCombinedVariationStatus from './getCombinedVariationStatus';

type ReadonlyJob = ReturnType<typeof useSnapshot<Job>>;

export default function getCombinedJobStatus(
  job?: ReadonlyJob,
): JobStatus | undefined {
  if (!job || !job.variationInfoByID) return undefined;

  const variations = Object.values(job.variationInfoByID);

  return getCombinedVariationStatus(variations);
}
